/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Muscles_Target_CaptionInputs */

const en_us2_wrapped_muscles_target_caption = /** @type {(inputs: Wrapped_Muscles_Target_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`weekly set target`)
};

const pt_br2_wrapped_muscles_target_caption = /** @type {(inputs: Wrapped_Muscles_Target_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`meta de séries da semana`)
};

const es_419_wrapped_muscles_target_caption = /** @type {(inputs: Wrapped_Muscles_Target_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`meta semanal de series`)
};

const pt_pt2_wrapped_muscles_target_caption = /** @type {(inputs: Wrapped_Muscles_Target_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`objetivo de séries da semana`)
};

const fr_fr2_wrapped_muscles_target_caption = /** @type {(inputs: Wrapped_Muscles_Target_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`objectif de séries de la semaine`)
};

const de_de2_wrapped_muscles_target_caption = /** @type {(inputs: Wrapped_Muscles_Target_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochenziel an Sätzen`)
};

const it_it2_wrapped_muscles_target_caption = /** @type {(inputs: Wrapped_Muscles_Target_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`obiettivo settimanale di serie`)
};

/**
* | output |
* | --- |
* | "weekly set target" |
*
* @param {Wrapped_Muscles_Target_CaptionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_muscles_target_caption = /** @type {((inputs?: Wrapped_Muscles_Target_CaptionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Muscles_Target_CaptionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_muscles_target_caption(inputs)
	if (locale === "es-419") return es_419_wrapped_muscles_target_caption(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_muscles_target_caption(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_muscles_target_caption(inputs)
	if (locale === "de-DE") return de_de2_wrapped_muscles_target_caption(inputs)
	if (locale === "it-IT") return it_it2_wrapped_muscles_target_caption(inputs)
	return en_us2_wrapped_muscles_target_caption(inputs)
});
export { wrapped_muscles_target_caption as "wrapped.muscles_target_caption" }